import type { RouteLocationNamedRaw } from "vue-router";

export interface BrowserNotificationState {
  vibrate?: boolean;
  sound?: HTMLAudioElement;
  iconPath?: string;
}

export enum NOTIFICATION_PERMISSION {
  GRANTED = "granted",
  DEFAULT = "default",
  DENIED = "denied",
}

export interface LocalNotification {
  title: string;
  body?: string;
  redirect?: RouteLocationNamedRaw;
  extraParams?: string;
}
